import type { DynamicComponent } from './dynamicComponent';
import type { DefinitionComponent } from './types';

export const createStrategyManager = (strategies: Array<DynamicComponent>) => {
  const CreateComponent = (definition: DefinitionComponent) => {
    const [dynamicComponent] = strategies.filter((component) => component.CanGet(definition.type));
    return dynamicComponent.Component(definition);
  };

  const CreateValidation = (definition: DefinitionComponent) => {
    const [dynamicComponent] = strategies.filter((component) => component.CanGet(definition.type));
    return dynamicComponent.Validations(definition);
  };

  return { CreateComponent, CreateValidation };
};
